import React, {
  useEffect,
  useMemo,
  useCallback,
  useState,
  useRef
} from "react";
import styles from "./index.module.scss";
import VaultTag from "../vault-tag";
import FTTag from "../ft-tag";
import AddressModal from "./AddressModal";
import moment from "moment";
import InfoTags from "./info-tags";
// import DateTag from "./date-tags";
// import AvatarFlipper from "./avatar";
import FlipperBottomBar from "./bottombar";
import ContactDropdown from "./contact-dropdown";
import { Sidebar } from "primereact/sidebar";
import InvestorActivity from "../../../pages/invesetor-activity";
import {
  InterestScoreClicked,
  InvestorEventsClicked,
  InvestorViewed,
  PurchaseHistoryViewed
} from "../../../utils/inv-exch-amplitude";
import { useSearchParams } from "react-router-dom";

export interface PRETypes {
  isFlipper: boolean;
  situsCity: string | null;
  situsZIP5: string | null;
  situsState: string | null;
  situsLatitude: string | null;
  situsLongitude: string | null;
  situsFullAddress: string | null;
  currentSalesPrice: number | null;
  currentSaleRecordingDate: string | null;
  concurrentMtg1Lender: string | null;
}

export interface FlipperVaultCardProps {
  acctId: string;
  acctSfid: string;
  acctName: string;
  vaultOwnerId: string | null;
  vaultOwnerName: string | null;
  interestScore: number;
  emailScore: number;
  hasCheckedOutByMe: string;
  bidCount: number;
  isCooldown: boolean;
  isInCallingPipeline: boolean;
  owner: Array<{
    id: string;
    name: string;
    sfid: string;
  }>;
  contacts: Array<{
    id: string;
    name: string;
    sfid: string;
    email: string;
    mobile: string;
  }>;
  checkouts: Array<{
    id: string;
    userId: string;
    expirtyAt: string;
    releasedAt: string | null;
    userName: string;
    createdAt: string;
  }>;
  engmtStatus: string;
  pre: PRETypes[];
  totalPurchased: string;
  totalSold: string;
  totalFlips: string;
  lastPurchased: string | null;
  lastSold: string | null;
  investorStatus: string;
  totalPurchasedFT: string;
  cooldownExpireAt?: string | null;
}

export default function FlipperVaultCard({
  flipperData,
  mostVisibleId
}: {
  flipperData: FlipperVaultCardProps;
  mostVisibleId: string | null;
}) {
  const userDetail = useMemo(() => {
    const userObj = localStorage.getItem("user-detail");
    return userObj ? JSON.parse(userObj) : null;
  }, []);
  const [showAddress, setShowAddress] = useState(false);
  const [openActivity, setOpenActivity] = useState(() => {
    const stored = sessionStorage.getItem(`activity-${flipperData.acctId}`);
    return stored ? JSON.parse(stored) : false;
  });
  const [isScrolled, setIsScrolled] = useState(false);
  const [contact, setContact] = useState(flipperData?.contacts?.[0] ?? null);
  const expiry =
    flipperData?.checkouts?.[flipperData?.checkouts?.length - 1]?.createdAt;
  const [showReleaseBtn, setShowReleaseBtn] = useState(
    expiry &&
      -moment.utc(expiry).diff(moment().utc(), "minutes") <=
        +`${process.env.REACT_APP_RELEASE_TIMER}`
      ? true
      : false
  );
  const [isExpired, setIsExpired] = useState(
    moment
      .utc(
        flipperData?.checkouts?.[flipperData?.checkouts?.length - 1]?.expirtyAt
      )
      .isBefore(moment().utc())
  );
  const [isNameExpanded, setIsNameExpanded] = useState(false);
  // DND / cooldown disabled for now — keep signed RPA + sold date only
  // const [cooldownText, setCooldownText] = useState<string>("");
  // const [isCooldownActive, setIsCooldownActive] = useState<boolean>(() => {
  //   if (!flipperData?.isCooldown || !flipperData?.cooldownExpireAt) {
  //     return false;
  //   }
  //   const target = moment.utc(flipperData?.cooldownExpireAt);
  //   return target.isValid() && target.isAfter(moment.utc());
  // });
  // const isCooldownActive = false; // DND disabled

  // Real-time cooldown countdown based on cooldownExpireAt
  // useEffect(() => {
  //   if (!flipperData?.isCooldown || !flipperData?.cooldownExpireAt) {
  //     setCooldownText("");
  //     setIsCooldownActive(false);
  //     return;
  //   }
  //
  //   const target = moment.utc(flipperData?.cooldownExpireAt);
  //   if (!target.isValid()) {
  //     setCooldownText("");
  //     setIsCooldownActive(false);
  //     return;
  //   }
  //
  //   const update = () => {
  //     const now = moment.utc();
  //     const diffMs = target.diff(now);
  //     if (diffMs <= 0) {
  //       setCooldownText("");
  //       setIsCooldownActive(false);
  //       return false;
  //     }
  //     setIsCooldownActive(true);
  //     const duration = moment.duration(diffMs);
  //     const totalDays = Math.floor(duration.asDays());
  //     const totalHours = Math.floor(duration.asHours());
  //     const totalMinutes = Math.floor(duration.asMinutes());
  //     const totalSeconds = Math.floor(duration.asSeconds());
  //
  //     if (totalDays >= 1) {
  //       setCooldownText(
  //         `${totalDays} ${totalDays === 1 ? "Day" : "Days"} Left`
  //       );
  //     } else if (totalHours >= 1) {
  //       setCooldownText(
  //         `${totalHours} ${totalHours === 1 ? "Hour" : "Hours"} Left`
  //       );
  //     } else if (totalMinutes >= 1) {
  //       setCooldownText(
  //         `${totalMinutes} ${totalMinutes === 1 ? "Min" : "Mins"} Left`
  //       );
  //     } else {
  //       setCooldownText(
  //         `${Math.max(totalSeconds, 0)} ${
  //           totalSeconds === 1 ? "Sec" : "Secs"
  //         } Left`
  //       );
  //     }
  //     return true;
  //   };
  //
  //   update();
  //   const id = setInterval(() => {
  //     if (!update()) {
  //       clearInterval(id);
  //     }
  //   }, 1000);
  //
  //   return () => {
  //     clearInterval(id);
  //   };
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [flipperData?.isCooldown, flipperData?.cooldownExpireAt]);

  const hideInfo = useMemo(() => {
    return (
      flipperData?.owner?.[0]?.id !== userDetail?.id &&
      flipperData?.vaultOwnerId !== userDetail?.id &&
      (isExpired ||
        flipperData?.checkouts?.[flipperData?.checkouts?.length - 1]
          ?.releasedAt !== null)
    );
  }, [
    flipperData?.vaultOwnerId,
    userDetail?.id,
    isExpired,
    flipperData?.checkouts
  ]);
  const { checkouts, owner, vaultOwnerId, bidCount } = flipperData;
  const lastCheckout = checkouts?.[checkouts?.length - 1];
  const vaultStatus = useMemo(() => {
    if (vaultOwnerId !== null) {
      if (vaultOwnerId === userDetail?.id) {
        // show My Vault
        return "MY VAULT";
      } else {
        if (lastCheckout?.userId === userDetail?.id) {
          if (isExpired) {
            return "EXPIRED";
          } else {
            if (bidCount && bidCount > 0) {
              return "BID PLACE";
            } else {
              return "CHECKED OUT";
            }
          }
        } else {
          return "LOCKED";
        }
      }
    } else {
      if (owner?.[0].id === userDetail?.id) {
        // owner and watching my account
        if (checkouts?.length > 0) {
          if (lastCheckout?.releasedAt !== null) {
            // have release data
            // show release by user Name in bottom bar and status will release
            return "RELEASED";
          } else if (isExpired) {
            // last checkout release date is null
            // check for expired condition
            // show expired by user name and status expired
            if (bidCount && bidCount > 0) {
              return "BID PLACED";
            } else {
              return "EXPIRED";
            }
          } else {
            // show checked out by user name and timer in bottom bar and status will by checked out
            if (bidCount && bidCount > 0) {
              return "BID PLACED";
            } else {
              return "CHECKED OUT";
            }
          }
        } else {
          if (bidCount && bidCount > 0) {
            return "BID PLACE";
          } else {
            return null;
          }
        }
      } else {
        // not owner and watching other's account
        if (checkouts?.length > 0) {
          if (lastCheckout?.releasedAt !== null) {
            if (lastCheckout?.userId === userDetail?.id) {
              // checked out by me and released
              return "RELEASED";
            } else {
              // not checked out by me and released by other
              // can see checkout button
              if (flipperData?.hasCheckedOutByMe === "1") {
                // show Locked
                return "CHECK OUT";
              }
              return null;
            }
          } else if (isExpired) {
            // release date is null
            // is expired
            if (lastCheckout?.userId === userDetail?.id) {
              // checked out by me and expired by me
              // show expired bidCount
              if (bidCount && bidCount > 0) {
                return "BID PLACED";
              } else {
                return "EXPIRED";
              }
            } else {
              // show checked out with lock icon
              return "CHECK OUT";
            }
          } else {
            if (lastCheckout?.userId === userDetail?.id) {
              // show release button and timer
              if (bidCount && bidCount > 0) {
                return "BID PLACE";
              } else {
                return "CHECKED OUT";
              }
            } else {
              // show Locked
              if (bidCount && bidCount > 0) {
                return "BID PLACED";
              } else {
                return "CHECK OUT";
              }
            }
          }
        } else {
          if (bidCount && bidCount > 0) {
            return "BID PLACED";
          } else {
            return null;
          }
        }
      }
    }
  }, [flipperData, userDetail?.id, isExpired]);

  useEffect(() => {
    if (flipperData?.contacts?.[0]) {
      setContact(flipperData.contacts[0]);
    }
  }, [flipperData?.contacts]);

  const handleScroll = useCallback((e: React.UIEvent<HTMLDivElement>) => {
    setIsScrolled(e.currentTarget.scrollTop > 0);
  }, []);
  const [searchParams] = useSearchParams();
  const pid = searchParams.get("pid") || "";
  const pubPropertySfid = searchParams.get("sfid") || "";

  useEffect(() => {
    if (mostVisibleId === flipperData.acctId) {
      InvestorViewed({
        property_id: pid,
        property_sfid: pubPropertySfid,
        investor_id: flipperData.acctId,
        investor_sfid: flipperData.acctSfid
      });
    }
  }, [mostVisibleId]);

  const handleAddressClick = useCallback(
    (acctId: string) => {
      if (
        flipperData?.owner?.[0]?.id === userDetail?.id ||
        vaultStatus === "MY VAULT" ||
        vaultStatus === "CHECKED OUT"
      ) {
        PurchaseHistoryViewed({
          property_id: pid,
          investor_id: acctId,
          property_sfid: pubPropertySfid,
          investor_sfid: flipperData?.acctSfid
        });
        setShowAddress((prev) => !prev);
      }
    },
    [vaultStatus]
  );

  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent | TouchEvent) => {
      if (cardRef.current && !cardRef.current.contains(event.target as Node)) {
        setShowAddress(false);
      }
    };

    // Mouse events
    document.addEventListener("mousedown", handleClickOutside);
    document.addEventListener("dragstart", handleClickOutside);

    // Touch events for mobile
    document.addEventListener("touchstart", handleClickOutside);
    document.addEventListener("touchmove", handleClickOutside);

    return () => {
      // Cleanup mouse events
      document.removeEventListener("mousedown", handleClickOutside);
      document.removeEventListener("dragstart", handleClickOutside);

      // Cleanup touch events
      document.removeEventListener("touchstart", handleClickOutside);
      document.removeEventListener("touchmove", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (openActivity) {
      sessionStorage.setItem(
        `activity-${flipperData.acctId}`,
        JSON.stringify(openActivity)
      );
    }
  }, [openActivity, flipperData.acctId]);

  return (
    <>
      {/* DND / cooldown UI disabled for now
      {isCooldownActive && (
        <div className={styles.cooldown}>
          <div className={styles.cooldownText}>
            <img src="/images/cooldown-icon.svg" alt="" />
            Investor on cooldown period
          </div>
          {cooldownText && (
            <div className={styles.cooldownDays}>{cooldownText}</div>
          )}
        </div>
      )}
      */}

      <div
        ref={cardRef}
        className={`${/* isCooldownActive ? styles.isCooldown : "" */ ""} ${
          styles.FlipperVaultCard
        } ${
          vaultStatus === "LOCKED" ||
          vaultStatus === "CHECK OUT" ||
          vaultStatus === "BID PLACED"
            ? styles.Locked
            : ""
        }`}
      >
        <div className={styles.FlipperVaultCardHeader}>
          <div className={styles.FlipperVaultCardHeaderTags}>
            <div className={styles.statusWrap}>
              <FTTag
                status={flipperData?.investorStatus}
                className={
                  vaultStatus === "LOCKED" ||
                  vaultStatus === "CHECK OUT" ||
                  vaultStatus === "BID PLACED"
                    ? "blur"
                    : ""
                }
              />
              
            </div>
            <VaultTag
              isWhite={vaultStatus === "LOCKED" || vaultStatus === "BID PLACED"}
              status={vaultStatus}
              isLocked={
                vaultStatus === "MY VAULT" ||
                vaultStatus === "LOCKED" ||
                vaultStatus === "BID PLACED"
              }
            />
          </div>
          {flipperData?.pre?.length > 0 &&
            (vaultStatus === "CHECKED OUT" ||
              vaultStatus === "MY VAULT" ||
              flipperData?.owner?.[0]?.id === userDetail?.id) && (
              <img
                onClick={() => handleAddressClick(flipperData?.acctId)}
                src={`/images/${
                  showAddress
                    ? "flipper-card-down-arrow.svg"
                    : "flipper-vault-arrow.svg"
                }`}
                alt=""
                className={`${styles.arrow} ${
                  flipperData?.owner?.[0]?.id === userDetail?.id ||
                  vaultStatus === "MY VAULT" ||
                  vaultStatus === "CHECKED OUT"
                    ? ""
                    : styles.disable
                }`}
              />
            )}
          <div
            className={`${styles.FlipperVaultCardContent} ${
              vaultStatus === "LOCKED" ||
              vaultStatus === "CHECK OUT" ||
              vaultStatus === "BID PLACED"
                ? "blur"
                : ""
            }`}
          >
            <div>
              <div className={styles.FlipperVaultCardTitle}>
                <div
                  className={`${!isNameExpanded ? styles.expanded : ""}`}
                  onClick={() => {
                    setIsNameExpanded(!isNameExpanded);
                  }}
                >
                  {flipperData?.acctName}
                </div>
              </div>
              <ContactDropdown
                flipperData={flipperData}
                hideInfo={
                  hideInfo ||
                  vaultStatus === "LOCKED" ||
                  vaultStatus === "CHECK OUT" ||
                  vaultStatus === "BID PLACED"
                }
                contact={contact}
                setContact={setContact}
              />
            </div>
            <div
              className={styles.FlipperVaultCardScore}
              onClick={() => {
                InterestScoreClicked({
                  investor_id: flipperData?.acctId,
                  property_sfid: pubPropertySfid,
                  investor_sfid: flipperData?.acctSfid,
                  property_id: pid || ""
                });
                if (
                  flipperData?.owner?.[0]?.id === userDetail?.id ||
                  vaultStatus === "MY VAULT" ||
                  vaultStatus === "CHECKED OUT" ||
                  vaultStatus === "BID PLACE"
                ) {
                  InvestorEventsClicked({
                    property_id: pid || "",
                    property_sfid: pubPropertySfid,
                    investor_id: flipperData?.acctId,
                    investor_sfid: flipperData?.acctSfid
                  });
                  setOpenActivity(true);
                }
              }}
            >
              <div
                className={`${styles.FlipperVaultCardScoreValue} ${
                  flipperData?.interestScore >= 50
                    ? styles.Green
                    : flipperData?.interestScore >= 30
                    ? styles.Yellow
                    : styles.Red
                }`}
              >
                {flipperData?.interestScore || 0}
              </div>
              INTEREST SCORE
            </div>
          </div>
        </div>

        <div
          className={`${showAddress ? styles.scrollWrap : ""} ${
            vaultStatus === "LOCKED" ||
            vaultStatus === "CHECK OUT" ||
            vaultStatus === "BID PLACED"
              ? "blur"
              : ""
          }`}
          onScroll={handleScroll}
        >
          <div className={styles.FlipperVaultCardInfo}>
            <InfoTags
              value={flipperData?.totalPurchased || "N/A"}
              title="Total Purchase PRE's"
            />
            <InfoTags
              value={flipperData?.totalPurchasedFT || "N/A"}
              title="Total Purchase FT"
            />
            <InfoTags
              value={flipperData?.totalSold || "N/A"}
              title="Total Sold"
            />
            <InfoTags
              value={flipperData?.totalFlips || "N/A"}
              title="Total Flipped"
            />
          </div>

          {/* <div className={styles.FlipperVaultCardDates}>
          <DateTag date={flipperData?.lastPurchased} title="Last Purchased" />
          <DateTag date={flipperData?.lastSold} title="Last Sold" />
        </div> */}

          {/* <div className={styles.FlipperVaultCardOwnerWrap}>
          <AvatarFlipper owner={flipperData?.owner} />
          <img
            src="/images/flipper-card-arrow.svg"
            alt=""
            className={
              flipperData?.owner?.[0]?.id === userDetail?.id ||
              vaultStatus === "MY VAULT" ||
              vaultStatus === "CHECKED OUT"
                ? ""
                : styles.disable
            }
            onClick={() => {
              if (
                flipperData?.owner?.[0]?.id === userDetail?.id ||
                vaultStatus === "MY VAULT" ||
                vaultStatus === "CHECKED OUT"
              ) {
                setOpenActivity(true);
              }
            }}
          />
          </div> */}
          {(flipperData?.owner?.[0]?.id === userDetail?.id ||
            vaultStatus === "MY VAULT" ||
            vaultStatus === "CHECKED OUT" ||
            vaultStatus === "BID PLACE") && (
            <Sidebar
              visible={openActivity}
              position="bottom"
              onHide={() => setOpenActivity(false)}
              className={styles.activityDrawer}
              maskClassName={styles.activityDrawerMask}
            >
              <InvestorActivity
                setOpenActivity={setOpenActivity}
                entityName={flipperData?.acctName}
                acctId={flipperData?.acctId}
              />
            </Sidebar>
          )}

          <div
            className={`${styles.bottomWrap} ${
              showAddress ? styles.openModel : styles.closeModel
            }`}
          >
            <FlipperBottomBar
              isCooldownActive={false /* isCooldownActive — DND disabled */}
              showReleaseBtn={showReleaseBtn}
              setShowReleaseBtn={setShowReleaseBtn}
              flipperData={flipperData}
              userDetail={userDetail}
              setIsExpired={setIsExpired}
              isExpired={isExpired}
              setHideInfo={() => {}}
            />
          </div>

          {(flipperData?.owner?.[0]?.id === userDetail?.id ||
            vaultStatus === "MY VAULT" ||
            vaultStatus === "CHECKED OUT" ||
            vaultStatus === "BID PLACE") &&
            showAddress && (
              <AddressModal
                isScrolled={isScrolled}
                preData={flipperData?.pre}
              />
            )}
        </div>
      </div>
    </>
  );
}
